import { useTranslation } from 'react-i18next';
import ClipboardCopy from '@lib/components/ClipboardCopy/ClipboardCopy';
import Typography from '@lib/components/Typography/Typography';
import entityViewStyles from '@lib/assets/styles/EntityView.module.scss';
import styles from '../SsoIntegrationView.module.scss';

const { VITE_API_URL } = import.meta.env;

function getSpUrls(code: string) {
  const base = `${VITE_API_URL}/sso/saml/${code}`;
  return {
    entityId: base,
    acsUrl: `${base}/callback`,
    metadataUrl: `${base}/metadata`,
  };
}

interface Props {
  code?: string;
}

export default function SpViewConfigurationSection({ code }: Props) {
  const { t } = useTranslation();
  const spUrls = getSpUrls(code || 'sso_xxx');

  return (
    <div className={entityViewStyles.infoList}>
      <Typography variant="h3" className={entityViewStyles.infoListTitle}>
        {t('sp-configuration')}
      </Typography>
      <div className={entityViewStyles.infoItem}>
        <p className={entityViewStyles.infoItemLabelWithoutIcon}>
          <Typography variant="caption">{t('entity-id')}</Typography>
        </p>
        <div className={entityViewStyles.infoItemContent}>
          <ClipboardCopy copyText={spUrls.entityId}>
            <Typography variant="body">{spUrls.entityId}</Typography>
          </ClipboardCopy>
        </div>
      </div>
      <div className={entityViewStyles.infoItem}>
        <p className={entityViewStyles.infoItemLabelWithoutIcon}>
          <Typography variant="caption">{t('acs-url')}</Typography>
        </p>
        <div className={entityViewStyles.infoItemContent}>
          <ClipboardCopy copyText={spUrls.acsUrl}>
            <Typography variant="body">{spUrls.acsUrl}</Typography>
          </ClipboardCopy>
        </div>
      </div>
      <div className={styles.divider}>
        <span className={styles.dividerLine} />
        <Typography variant="caption" className={styles.dividerText}>
          {t('or')}
        </Typography>
        <span className={styles.dividerLine} />
      </div>
      <div className={entityViewStyles.infoItem}>
        <p className={entityViewStyles.infoItemLabelWithoutIcon}>
          <Typography variant="caption">{t('metadata-url')}</Typography>
        </p>
        <div className={entityViewStyles.infoItemContent}>
          <ClipboardCopy copyText={spUrls.metadataUrl}>
            <Typography variant="body">{spUrls.metadataUrl}</Typography>
          </ClipboardCopy>
        </div>
      </div>
    </div>
  );
}
